import { makeStyles } from '@material-ui/core';
import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { COLORS } from '../../../constants/colors';
import { TAB_LINK } from '../../../constants/props';

const useStyles = makeStyles({
  root: {
    position: 'relative',
    height: '100%',
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    fontSize: '1.5rem',
    lineHeight: '5.75rem',
    color: COLORS.grayScale[5],
    textTransform: 'uppercase',
    textDecoration: 'none',
    ['@media (max-width:900px)']: {
      fontSize: '1rem',
      lineHeight: '2rem',
   },
  },
  active: {
    '&::after': {
      height: '.3125rem',
      width: '100%',
      position: 'absolute',
      bottom: 0,
      content: 'close-quote',
      backgroundColor: COLORS.primary.main,
    },
  },
});

const TabLink = ({ to, label }) => {
  const classes = useStyles();
  const match = useRouteMatch({ path: to, exact: true });

  return (
    <div
      className={
        match ? [classes.root, classes.active].join(' ') : classes.root
      }
    >
      <Link className={classes.link} to={to}>
        {label}
      </Link>
    </div>
  );
};

TabLink.propTypes = {
  TAB_LINK,
};

export default TabLink;
